var initializeScripts 		= require('../functions/initializeScripts');

$('.lazy').on('lazyshow', function(e){
	var $el = $(this);
    $el.removeClass('lazy-hidden')
        .addClass('animated ' + $el.attr('data-effect'));
});

$.extend($.lazyLoadXT, {
	edgeY:  300
});

window.onload=function() {
	(function(d) {
	 var ce=function(e,n){var a=document.createEvent("CustomEvent");a.initCustomEvent(n,true,true,e.target);e.target.dispatchEvent(a);a=null;return false},
	 nm=true,sp={x:0,y:0},ep={x:0,y:0},
	 touch={
	  touchstart:function(e){sp={x:e.touches[0].pageX,y:e.touches[0].pageY}},
	  touchmove:function(e){nm=false;ep={x:e.touches[0].pageX,y:e.touches[0].pageY}},
	  touchend:function(e){if(nm){ce(e,'fc')}else{var x=ep.x-sp.x,xr=Math.abs(x),y=ep.y-sp.y,yr=Math.abs(y);if(Math.max(xr,yr)>20){ce(e,(xr>yr?(x<0?'swl':'swr'):(y<0?'swu':'swd')))}};nm=true},
	  touchcancel:function(e){nm=false}
	 };
	 for(var a in touch){d.addEventListener(a,touch[a],false);}
	})(document);
}

document.addEventListener('DOMContentLoaded', function() {

	setTimeout(function(){
		if($('.fancybox-overlay').length){
			$('body').addClass('custom-fancybox');
		}

		$('.custom-fancybox .fancybox-overlay-fixed').on('click', function() {
			$(this).remove();
			$('.fancybox-wrap').remove();
			$('html').removeClass('fancybox-lock').removeClass('fancybox-margin');
		});
	}, 0);

	$('.nav-primary .has-subnodes').doubleTapToGo();

	var $body = document.getElementsByTagName('body')[0];

	$body.classList.add('loaded');

	initializeScripts();

});